import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSelectComponent } from './input-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorsLabelModule } from '../errors-label/errors-label.module';
import { DirectiveModule } from '@/directives/directive.modules';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [InputSelectComponent],
  imports: [
    CommonModule,
    ErrorsLabelModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    DirectiveModule,
  ],
  exports: [InputSelectComponent],
})
export class InputSelectModule {}
